<div class="container" *ngIf="true">
  <nav class="side-bar-content">
    <ion-grid>
      <ion-row>
        <ion-col>BUSCADOR</ion-col>
        <ion-col>
          <span class="close-button">X</span>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div >
      <ion-input
      class="select-filters"
      placeholder="{{search ? ' ' : 'Ingrese el texto'}}"
      fill="outline"
      [(ngModel)]="search"
    ></ion-input>
    </div>
    <div *ngFor="let well of wellList | groupBy : 'field'">
      <ion-accordion-group [multiple]="true" [value]="['Castilla', 'third']">
        <ion-accordion [value]="well.key" >
          <ion-item slot="header" color="primary">
            <ion-label>{{ well.key | titlecase }}</ion-label>
          </ion-item>
          <div slot="content" class="accordion-content" class="list-dmu">
            <div *ngFor="let item of well.value | filterByProperty : 'name' : search" class="accordion-item">
              <ion-item class="item-background-color" (click)="this.mapService.setCenterMap(item.lat, item.lon);">
                <ion-label>{{ item.name }}</ion-label>
              </ion-item>
              <!-- <ion-checkbox
                labelPlacement="end"
                slot="start"
                aria-label="label.name"
                >
              </ion-checkbox> -->
            </div>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </div>
  </nav>
</div>
